import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a1798d7d6425f00148c595c_1787765157402_bd842a20/lra_nexus/src/app/enterprise-admin/components/EnterpriseAdminClient.tsx");
